var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "animated fadeInUp", class: `delay${_vm.delay}` },
    [
      _c(
        "div",
        {
          staticClass:
            "panelCard panelCard--hover padding-all-10 margin-bottom-20 overflow-hidden pos-relative cursor-pointer",
          attrs: { role: "button", tabindex: "0" },
          on: {
            click: function ($event) {
              return _vm.$emit("show-release-modal", _vm.releaseItem)
            },
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.$emit("show-release-modal", _vm.releaseItem)
            },
          },
        },
        [
          _c("span", {
            staticClass: "hrPrimaryLeft--3",
            class: `content--${
              _vm.filterByContentType
                ? _vm.releaseItem.contentType
                : _vm.releaseItem.contentCategory
            }`,
          }),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.localizedDate(_vm.releaseItem.releaseDate.date))),
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "h5 hl-panelBoxSmall" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.releaseItem.title) + "\n        "
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }